"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isURLValidAndNotEmpty = exports.isValidUrl = exports.maybeAddFallbackProtocol = exports.getFinalRedirectURL = void 0;
var lodash_1 = require("lodash");
var validator_1 = __importDefault(require("validator"));
var getFinalRedirectURL = function (url, params) {
    if ((0, lodash_1.isEmpty)(url)) {
        return "";
    }
    var finalUrl = new URL(url);
    Object.keys(params).forEach(function (key) {
        finalUrl.searchParams.append(key, "".concat(params[key]));
    });
    return finalUrl.toString();
};
exports.getFinalRedirectURL = getFinalRedirectURL;
var ACCEPTED_PROTOCOLS = ["https", "http"];
var maybeAddFallbackProtocol = function (url) {
    return url === "" || validator_1.default.isURL(url, { require_protocol: true, protocols: ACCEPTED_PROTOCOLS })
        ? url
        : "https://".concat(url);
};
exports.maybeAddFallbackProtocol = maybeAddFallbackProtocol;
var isValidUrl = function (url) {
    return validator_1.default.isURL(url, { protocols: ACCEPTED_PROTOCOLS });
};
exports.isValidUrl = isValidUrl;
var isURLValidAndNotEmpty = function (url) {
    return url !== "" && isValidUrl(url);
};
exports.isURLValidAndNotEmpty = isURLValidAndNotEmpty;
